import type { MovementConfig } from '../config/movements';
import type { KitGroup, WizardLine, WizardVariant } from '../types/wizard';

/**
 * AUT vs manual TRANSFER_TYPE is driven only by customer LOB + Account_Group
 * (`useAutoTransferType` from `/customer_details`). Kit structure does not affect this.
 */

export function usesAutoTransferType(
  movement: MovementConfig,
  useAuto: boolean
): boolean {
  return useAuto && Boolean(movement.transferTypeKit);
}

export function resolveAutoTransferType(movement: MovementConfig): string {
  return movement.transferTypeKit ?? movement.transferTypeFlat ?? '';
}

export function resolveManualTransferType(movement: MovementConfig): string {
  return movement.transferTypeFlat ?? movement.transferTypeKit ?? '';
}

export function resolveStandardTransferType(
  movement: MovementConfig,
  useAuto: boolean
): string {
  return usesAutoTransferType(movement, useAuto)
    ? resolveAutoTransferType(movement)
    : resolveManualTransferType(movement);
}

export function resolveTransferOutDocSubType(
  movement: MovementConfig,
  useAuto: boolean
): string {
  if (!usesAutoTransferType(movement, useAuto)) {
    return movement.transferTypeFlat ?? 'TROUT';
  }
  return movement.transferTypeKit ?? 'TROUT_AUTO';
}

/** Kit vs flat ITEMS rows — from order structure only; unrelated to AUT transfer type. */
export function shouldBuildKitItems(
  kitGroups: KitGroup[],
  variant?: WizardVariant,
  lines?: WizardLine[]
): boolean {
  return (
    kitGroups.length > 0 ||
    variant === 'kit' ||
    Boolean(lines?.some((l) => l.isKitHeader))
  );
}
